import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=e7fe1e0a"
import script from "./search-results.vue?vue&type=script&lang=ts"
export * from "./search-results.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports